/**
 * @prettier
 */

import { useEffect } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { openModal as openModalAction } from 'cards/actions/modalActions';
import FeatureFlags from '../../../../../util/featureFlags';

export const TutorialModalEntryBase = ({ openModal }) => {
  const localStorageKey = 'ZOLA_INVITATIONS_SINGLE_SAMPLE_MODAL_MULTI_TUTORIAL_SEEN';

  useEffect(() => {
    // TODO: show modal on first load if marketplace modal is not showing
    // const tutorialSeen = localStorage.getItem(localStorageKey);
    const { query } = browserHistory.getCurrentLocation();

    if (
      FeatureFlags.get('invitesMultiSampleTutorialModal') &&
      query.multi_sample_tutorial === '1'
    ) {
      localStorage.setItem(localStorageKey, 'true');

      openModal();
    }
  }, [openModal]);

  return null;
};

export const mapDispatchToProps = dispatch => ({
  openModal: () => dispatch(openModalAction('MULTI_SAMPLES_TUTORIAL', {}, { size: 'sm' })),
});

export default connect(null, mapDispatchToProps)(TutorialModalEntryBase);
